import {
  H2_SERVICES_IMG01,
  H2_SERVICES_IMG02,
  H2_SERVICES_IMG03,
  H2_SERVICES_IMG04,
  H4_SERVICES_IMG01,
  H4_SERVICES_IMG02,
  H4_SERVICES_IMG03,
  H4_SERVICES_IMG04,
  SERVICES_IMG01,
  SERVICES_IMG02,
  SERVICES_IMG03,
  SERVICES_ITEM_SHAPE,
} from "../lib/assets";

export const SERVICES_TWO_LIST = [
  {
    id: 1,
    src: H2_SERVICES_IMG02,
    srcShape: SERVICES_ITEM_SHAPE,
    icon: "flaticon-life-insurance", // Asegúrate de tener este ícono o uno similar
    href: "/#",
    title: "Seguros de Vida",
    subtitle: "🔒 Protección para ti y tus seres queridos.",
  },
  {
    id: 2,
    src: H2_SERVICES_IMG03,
    srcShape: SERVICES_ITEM_SHAPE,
    icon: "flaticon-house", // Ícono sugerido para hogar
    href: "/#",
    title: "Seguros para Hogar",
    subtitle: "🏡 Cuidamos tu patrimonio y tranquilidad.",
  },
  {
    id: 3,
    src: H2_SERVICES_IMG01,
    srcShape: SERVICES_ITEM_SHAPE,
    icon: "flaticon-car-insurance", // Ícono sugerido para vehículos
    href: "/#",
    title: "Seguros para Vehículos",
    subtitle: "🚗 Conduce seguro en todo momento.",
  },
  {
    id: 4,
    src: H2_SERVICES_IMG04,
    srcShape: SERVICES_ITEM_SHAPE,
    icon: "flaticon-piggy-bank", // Ícono sugerido para empresas
    href: "/#",
    title: "Seguros Empresariales",
    subtitle: "🏢 Protección integral para tu empresa.",
  },
];

export const SERVICES_THREE_LIST = [
  {
    id: 1,
    src: H4_SERVICES_IMG01,
    icon: "flaticon-healthcare",
    href: "/#",
    title: "Health Insurance",
    subtitle: "Morem ipsum dolor ametey consectre adipiscing.",
  },
  {
    id: 2,
    src: H4_SERVICES_IMG02,
    icon: "flaticon-protection",
    href: "/#",
    title: "Vehicle Insurance",
    subtitle: "Morem ipsum dolor ametey consectre adipiscing.",
  },
  {
    id: 3,
    src: H4_SERVICES_IMG03,
    icon: "flaticon-ship",
    href: "/#",
    title: "Cargo Insurance",
    subtitle: "Morem ipsum dolor ametey consectre adipiscing.",
  },
  {
    id: 4,
    src: H4_SERVICES_IMG04,
    icon: "flaticon-house",
    href: "/#",
    title: "Fire Insurance",
    subtitle: "Morem ipsum dolor ametey consectre adipiscing.",
  },
];

export const SERVICES_FOUR_LIST = [
  {
    id: 1,
    icon: "flaticon-business-presentation",
    href: "/#",
    title: "Marketing Strategy",
    subtitle:
      "When An Unknown Printer Took Gerty Galley Types Awecr Erambled Type Specimen Book.",
  },
  {
    id: 2,
    icon: "flaticon-rocket",
    href: "/#",
    title: "SEO Consultancy",
    subtitle:
      "When An Unknown Printer Took Gerty Galley Types Awecr Erambled Type Specimen Book.",
  },
  {
    id: 3,
    icon: "flaticon-mission",
    href: "/#",
    title: "Target Audience",
    subtitle:
      "When An Unknown Printer Took Gerty Galley Types Awecr Erambled Type Specimen Book.",
  },
];
export const SERVICES_ONE_LIST = [
  {
    id: 1,
    icon: "flaticon-briefcase",
    href: "/#",
    src: SERVICES_IMG01,
    title: "Seguro de Vida Individual",
    subtitle: "Protección a largo plazo para ti y tu familia. Acceso a coberturas flexibles. Apoyo económico en momentos difíciles.",
  },
  {
    id: 2,
    icon: "flaticon-briefcase",
    href: "/#",
    src: SERVICES_IMG02,
    title: "Seguro de Vida Grupo",
    subtitle: "Ideal para empleados o colectivos. Tarifas preferenciales. Cobertura ante fallecimiento o invalidez.",
  },
  {
    id: 3,
    icon: "flaticon-briefcase",
    href: "/#",
    src: SERVICES_IMG03,
    title: "Seguro de Educación",
    subtitle: "Asegura el futuro académico de tus hijos. Planificación financiera a largo plazo. Cobertura ante imprevistos.",
  },
  {
    id: 4,
    icon: "flaticon-briefcase",
    href: "/#",
    src: SERVICES_IMG02,
    title: "Seguro de Salud",
    subtitle: "Amplia red médica y hospitalaria. Planes individuales y familiares. Cobertura nacional.",
  },
  {
    id: 5,
    icon: "flaticon-briefcase",
    href: "/#",
    src: "",
    title: "Seguro de Accidentes",
    subtitle: "Asistencia médica inmediata. Indemnización por incapacidad o muerte accidental. Cobertura 24/7.",
  },
  {
    id: 6,
    icon: "flaticon-briefcase",
    href: "/#",
    src: "",
    title: "Seguro de Pensión Voluntaria",
    subtitle: "Ahorro flexible para tu retiro. Beneficios tributarios. Opciones de renta vitalicia.",
  },
  {
    id: 7,
    icon: "flaticon-briefcase",
    href: "/#",
    src: "",
    title: "Seguro de Rentas",
    subtitle: "Ingresos programados. Tranquilidad financiera mensual. Ideal para planificación familiar.",
  },
  {
    id: 8,
    icon: "flaticon-briefcase",
    href: "/#",
    src: "",
    title: "RC Médica",
    subtitle: "Protección ante demandas por negligencia. Cobertura a profesionales de la salud. Acompañamiento legal especializado.",
  },
  {
    id: 9,
    icon: "flaticon-briefcase",
    href: "/#",
    src: "",
    title: "Seguros Empresariales, Patrimoniales e Ingeniería",
    subtitle: "Cobertura integral para empresas, patrimonios y proyectos de ingeniería.",
  },
  {
    id: 10,
    icon: "flaticon-briefcase",
    href: "/#",
    src: "",
    title: "Todo Riesgo Daños Materiales",
    subtitle: "Cobertura ante incendios, terremotos, robos. Protección integral para instalaciones.",
  },
  {
    id: 11,
    icon: "flaticon-briefcase",
    href: "/#",
    src: "",
    title: "Seguro de Hogar",
    subtitle: "Protección contra daños materiales y robos. Asistencia domiciliaria. Responsabilidad civil incluida.",
  },
  {
    id: 12,
    icon: "flaticon-briefcase",
    href: "/#",
    src: "",
    title: "Seguro de Automóviles",
    subtitle: "Cobertura para autos particulares, pesados, motos y servicio público. Asistencia en carretera. Daños a terceros y pérdida total.",
  }
];

